import React from "react";
import Image from "components/image";
import getContainerSizeClass from "@root/helpers/get-container-size-class";

const ImageBanner = ({ data }) => {
    const classes = getContainerSizeClass(data?.moduleSettings);
    const height = data?.height;
    return (
        <div 
            className={`image-banner ${data?.tabletImage?.asset ? "image-banner--has-tablet" : ""} ${classes.join(" ")}`}
            style={{ "--height": `${height}px`, marginTop: classes.join(" ").includes('wide') ? -16 : 0 }}
        >
            <div className="image-banner__desktop-image">
                <Image 
                    className="image-banner__image"
                    image={data?.desktopImage}
                    to={data?.url}
                    width={false}
                    style={{ objectFit: "cover" }}
                    removeSrcset={true}
                />
            </div>
            {data?.tabletImage?.asset && (
                <div className="image-banner__tablet-image">
                    <Image 
                        className="image-banner__image"
                        image={data?.tabletImage}
                        to={data?.url} 
                        style={{ objectFit: "cover" }}
                    />
                </div>
            )}
            <div className="image-banner__mobile-image">
                <Image 
                    className="image-banner__image"
                    image={data?.mobileImage}
                    to={data?.url} 
                    style={{ objectFit: "cover" }}
                />
            </div>
        </div>
    );
};

export default ImageBanner;